import { useLayoutEffect, useRef, useState } from 'react';

const useRevealEllipsisInTooltip = (cellWidth?: number | string) => {
  const tooltipRef = useRef<HTMLDivElement | HTMLSpanElement>(null);
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    if (tooltipRef.current) {
      setWidth(tooltipRef.current.offsetWidth);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tooltipRef.current, cellWidth]);

  return {
    tooltipRef,
    width,
  };
};

export default useRevealEllipsisInTooltip;
